import { storage } from "./api";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { updateProfilePhoto } from "./apiUser";
import { updatePetPhoto } from "./apiPet";
import { updateForoPhoto } from "./apiForum";


/**
 * Función para subir una foto a Firebase Storage
 * @param {string} path ubicación donde se guardará la foto
 * @param {string} fileName nombre del archivo
 * @param {File} file archivo a subir (foto)
 * @returns 
 */
const uploadPhoto = async (path, fileName, file) => {
    try {
        // obtener extensión del archivo
        const extension = file.name.split(".").pop();
        // referencia al archivo
        const fileRef = ref(storage, `${path}/${fileName}.${extension}`);
        await uploadBytes(fileRef, file);
        const url = await getDownloadURL(fileRef);
        return url;
    } catch (error) {
        console.error(error);
        return null;
    }
}


/**
 * Función para subir una foto de perfil a Firebase Storage
 * @param {string} userId id del usuario
 * @param {File} file archivo a subir (foto)
 * @returns {boolean} retorna verdadero si actualizo la foto
 */
export const uploadProfilePhoto = async (userId, file) => {
    try {
        const path  = `profile/${userId}`
        const url = await uploadPhoto(path, userId, file);
        if (url === null) return false;
        const updateStatus = await updateProfilePhoto(userId, url);
        return updateStatus;
    } catch (error) {
        console.error(error);
        return false;
    }
}


/**
 * Función para subir una foto de una mascota a Firebase Storage
 * @param {string} petId id de la mascota
 * @param {File} file archivo a subir (foto)
 * @returns {boolean} retorna verdadero si actualizo la foto
 */
export const uploadPetPhoto = async (petId, file) => {
    try {
        const path = `pets/${petId}`;
        const url = await uploadPhoto(path, petId, file);
        const updateStatus = await updatePetPhoto(petId, url);
        return updateStatus;
    } catch (error) {
        console.error(error);
        return null;
    }
}

/**
 * Función para subir una foto de un foro a Firebase Storage
 * @param {string} foroId id del foro
 * @param {File} file archivo a subir (foto)
 * @returns {boolean} retorna verdadero si actualizo la foto
 */
export const uploadForoPhoto = async (foroId, file) => {
    try {
        const path = `foros/${foroId}`;
        const url = await uploadPhoto(path, foroId, file);
        const updateStatus = await updateForoPhoto(foroId, url);
        return updateStatus;
    } catch (error) {
        console.error(error);
        return null;
    }
}